import { render, staticRenderFns } from "./CDateFieldView.vue?vue&type=template&id=661f2666&scoped=true&"
import script from "./CDateFieldView.vue?vue&type=script&lang=js&"
export * from "./CDateFieldView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f2666",
  null
  
)

export default component.exports